import GameStateControl from "../../GameStateControl";
import { Settings } from "../../Settings";
import Totals from "../crew/Totals";
import BigNum from "../math/BigNum";
import GameTime from "../time/GameTime";
import Values from "../value/Values";
import BaseAutomation from "./BaseAutomation";

export default class PrestigeAutomation extends BaseAutomation {
    /**
     * @param {GameTime} gameTime
     * @param {Values} values 
     * @param {GameStateControl} gameStateControl
     * @param {Totals} totals
     */
    constructor(gameTime, values, gameStateControl, totals) {
        super(gameTime, values.prestigeAutomationUnlocked, values.prestigeAutomationRateUpgrades, 
            Settings.automation.prestigeUpgradeDelayTurns, Settings.automation.prestigeTurnsPerRateUpgrade);

        /**
         * @constant
         * @type {GameStateControl}
         */
        this.gameStateControl = gameStateControl;

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;

        /**
         * @type {BigNum}
         */
        this.prevUnclaimedPrestige = new BigNum(1E34); // Set it to some huge number
    }

    /**
     * @override
     */
    updateForTurn() {
        if (this.totals.unclaimedPrestige.greaterThanZero()) {
            
            // If unclaimed prestige changes, then start a timer.
            if (!this.prevUnclaimedPrestige.equals(this.totals.unclaimedPrestige)) {
                this.prevUnclaimedPrestige.copy(this.totals.unclaimedPrestige);

                this.lastAutomationTurn = this.gameTime.turnNumber;
                this.lastAutomationFrame = this.gameTime.frameNumber;
            }

            super.updateForTurn();
        }
    }

    /**
     * @override
     * This is invoked by the super class when it is time.
     */
    purchaseUpgrade() {
        this.gameStateControl.prestigeGame();
    }

    /////////////////////////////////////////
    // GameModel
    /////////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        super.resetFull();
        this.resetInternal();
    }

    /**
     * @override
     */
    resetForPrestige() {
        super.resetForPrestige();
        this.resetInternal();
    }

    resetInternal() {
        this.prevUnclaimedPrestige.setValue(1E34); // just some number to make sure it's different
    }

}